// src/components/CustomLineChart.jsx
import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{
        background: "transparent", // 흰색 박스 제거
        padding: 0,
        color: "red",
        fontWeight: "700",
        fontSize: "0.9rem",
      }}>
        {payload[0].value}% {/* value만 표시 */}
      </div>
    );
  }
  return null;
};

const CustomLineChart = ({ chartData }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={chartData}
        margin={{ top: 5, right: 15, left: 15, bottom: 25 }} // X축 공간 확보
      >
        <Line
          type="monotone"
          dataKey="value"
          stroke="Red"
          strokeWidth={3}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
        <XAxis
          dataKey="label"
          interval={0}          // 모든 tick 강제 표시
          tick={{ fontSize: 12 }}
          angle={-20}          // 글자 기울기
          textAnchor="end"
          height={25}           // X축 높이 확보
        />
        <YAxis hide />
        <Tooltip content={<CustomTooltip />} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default CustomLineChart;
